import gsap from 'gsap';
import MediaItem from './MediaItem';
import NativeMediaControls from '../utils/NativeMediaControls';

export default class AudioMedia extends MediaItem {
  constructor(model, app, audio) {
    super(app);
    this._greensockTimeline = gsap.timeline();
    this.audio = audio;
    this.audioControls = new NativeMediaControls(audio);
    this.fadeIn = model.fadeIn ?? 0;
    this.fadeOut = model.fadeOut ?? 0;
    this.playbackVolume = audio.volume ?? 1;

    this.updateModel(model);
  }

  updateModel(model) {
    this.trimStart = model.trimStart;
    if (model.startTime < 0) {
      // treat audio before time 0 as if it has been trimmed away
      this.trimStart -= model.startTime;
    }
    super.updateModel(model);
    this.greensockTimeline.clear();

    const { fadeIn, fadeOut, volume } = model;
    const modelVolumeSet = !isNaN(parseFloat(volume));

    if (modelVolumeSet && volume !== this.playbackVolume) {
      this.setPlaybackVolume(model.volume);
    }

    if (fadeIn || fadeOut) {
      this.fade(fadeIn, fadeOut, modelVolumeSet ? volume : this.playbackVolume);
    }
  }

  play() {
    if (!this.audio.ended) {
      this.audioControls.play();
    }
  }

  mute() {
    this.audioControls.mute();
  }

  unmute() {
    this.audioControls.unmute();
  }

  setPlaybackVolume(volume) {
    this.playbackVolume = volume;
    this.audioControls.setPlaybackVolume(volume);
  }

  pause() {
    this.audioControls.pause();
  }

  seek(timestamp) {
    return this.audioControls.seek(timestamp + this.trimStart);
  }

  fade(fadeIn, fadeOut, volume) {
    this.fadeIn = fadeIn;
    this.fadeOut = fadeOut;

    if (fadeIn > 0) {
      this.greensockTimeline.fromTo(
        this.audio,
        { volume: 0 },
        { volume, duration: fadeIn }
      );
    }

    if (fadeOut > 0) {
      this.greensockTimeline.fromTo(
        this.audio,
        { volume },
        {
          volume: 0,
          duration: fadeOut,
          onComplete: () => {
            this.audio.volume = volume;
          },
        },
        this.duration - fadeOut
      );
    }
  }

  get greensockTimeline() {
    return this._greensockTimeline;
  }
}
